import config from '../config';

const api = url => `${config.API_BASE_URL}/api/${url}`;

export default api;
